/* Only this small delegated entry point loads before Edit is requested.
   [data-cart-edit] = cart line "Edit options"; [data-cart-add] = "+ ADD" on a custom product (PDP "You may also like"),
   an <a href> to the product page so it still works if the editor cannot load. */
(() => {
  const {editor, editorCss} = document.currentScript.dataset;
  let loading;
  const assets = new Map();
  function loadAsset(url, isScript) {
    if (assets.has(url)) return assets.get(url);
    const node = document.createElement(isScript ? 'script' : 'link');
    if (isScript) node.src = url;
    else { node.rel = 'stylesheet'; node.href = url; }
    const request = new Promise((resolve, reject) => {
      node.onload = () => { node.onload = node.onerror = null; resolve(); };
      node.onerror = () => {
        node.onload = node.onerror = null;
        assets.delete(url); node.remove();
        reject(new Error('Unable to load the editor. Please try again.'));
      };
    });
    assets.set(url, request);
    document.head.append(node);
    return request;
  }
  function load() {
    if (!loading) {
      let timer;
      loading = Promise.race([
        Promise.all([loadAsset(editorCss, false), loadAsset(editor, true)]),
        new Promise((resolve, reject) => {
          timer = setTimeout(() => reject(new Error('Unable to load the editor. Please try again.')), 15000);
        })
      ]).catch(error => { loading = null; throw error; }).finally(() => clearTimeout(timer));
      // 超时只结束等待；保留在途资源，重试不重复执行仍可能迟到的编辑器脚本。
    }
    return loading;
  }
  function waitForCartReady() {
    if (!window.CartFlow?.busy) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const finish = error => {
        clearTimeout(timer); document.removeEventListener('cart:busy', check);
        if (error) reject(error); else resolve();
      };
      const check = () => {
        if (!window.CartFlow?.busy || window.CartFlow.checkout || window.CartFlow.uncertain) finish();
      };
      const timer = setTimeout(() => finish(new Error('Please wait for your cart to finish updating, then try again.')), 15000);
      document.addEventListener('cart:busy', check); check();
    });
  }
  // ADD 仍预取商品选项；Edit 只预载资源，点击后才读取最新商品和购物车数据。
  function warm(event) {
    const button = event.target.closest?.('[data-cart-add], [data-cart-edit]');
    if (!button || button.disabled || button.dataset.warmed) return;
    button.dataset.warmed = '1';
    load().then(() => {
      if (button.hasAttribute('data-cart-add')) return window.CartEditor.prefetch(button);
    }).catch(() => { delete button.dataset.warmed; });
  }
  ['pointerover', 'focusin', 'touchstart'].forEach(type => document.addEventListener(type, warm, {passive:true}));
  // Shown under the ADD when the options dialog cannot open. This page (and anything already chosen on it) stays;
  // the product page opens in a new tab, as the link always did. Styled inline: the editor CSS may be what failed.
  function fallback(button, text) {
    button.parentElement.querySelector('.cart-add-fallback')?.remove();
    const note = document.createElement('p');
    note.className = 'cart-add-fallback'; note.setAttribute('role', 'alert');
    note.style.cssText = 'margin:6px 0 0;font-size:12px;line-height:1.4;color:#cc2626;text-transform:none;';
    const link = document.createElement('a');
    // A <button data-cart-add> (deals pages, kept off GTM's link-click trigger) has no href; its data-url is the product page.
    link.href = button.href || button.dataset.url; link.target = '_blank'; link.rel = 'noopener'; link.textContent = 'Open the product page';
    link.style.cssText = 'color:inherit;text-decoration:underline;';
    note.append(text + ' ', link);
    button.after(note);
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-edit], [data-cart-add]');
    if (!button) return;
    // Ctrl/Cmd/Shift-click on the ADD link keeps its normal "open the product page" meaning.
    if (button.matches('a[data-cart-add]') && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
    event.preventDefault();
    if (button.disabled) return;
    // Only the text changes while loading; the pencil icon stays.
    const text = button.querySelector('.cart-item-details__edit-label') || button;
    const label = text.textContent;
    button.disabled = true; button.setAttribute('aria-busy', 'true'); text.textContent = 'Loading…';
    button.parentElement?.querySelector('.cart-add-fallback')?.remove();
    try {
      await load();
      // 首次 Cart refresh 尚未结束时保留 loading；稳定后编辑器仍读取最新行，不重复刷新或写入。
      if (button.hasAttribute('data-cart-edit')) await waitForCartReady();
      await (button.hasAttribute('data-cart-add') ? window.CartEditor.add(button) : window.CartEditor.open(button));
    }
    catch (error) {
      // The cart's error slot lives in the (closed) drawer, so on a product page it would go unseen.
      if (button.hasAttribute('data-cart-add') && !document.querySelector('dialog.cart-editor[open]')) fallback(button, error.message);
      else window.CartFlow?.error(error.message);
    }
    finally { button.disabled = false; button.removeAttribute('aria-busy'); text.textContent = label; }
  });
})();
